<div class="modal-body modal-body-container">
  <div class="change-deadline-container d-flex justify-content-center flex-column m-b-15">
      <div class="d-flex justify-content-between m-b-20">
          <div class="title">Change deadline</div>
          <button type="button" class="close pull-right close-modal-btn" aria-label="Close" (click)="modalRef.hide()"></button>
      </div>
      <div class="m-b-20" (click)="$event.stopPropagation()">
          <input type="text" #dt="bsDatepicker" 
                  [(ngModel)]="date"
                  [minDate]="minDate" bsDatepicker
                  [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY' }" />
          <i (click)="dt.toggle()" class="fa fa-calendar"></i>
      </div>
  </div>
  <div class="modal-footer d-flex justify-content-end p-0">
      <button class="cancel-btn" (click)="modalRef.hide()"> Cancel </button>
      <button class="reopen-process-btn" (click)="onSaveClicked()"> Save changes </button>
    </div>
</div>